import { toYYYYMMDD } from '../../helpers'

export type VendorPerformancePreset =
    | 'last_month'
    | 'last_quarter'
    | 'last_12_months'
    | 'all_time'

export const DEFAULT_VENDOR_PERFORMANCE_PRESET: VendorPerformancePreset =
    'last_12_months'

export const getPresetRange = (
    preset: VendorPerformancePreset,
): { startDate?: string; endDate?: string } => {
    if (preset === 'all_time') {
        return {}
    }

    const today = new Date()
    today.setHours(0, 0, 0, 0)

    if (preset === 'last_12_months') {
        const start = new Date(today)
        start.setFullYear(start.getFullYear() - 1)
        return {
            startDate: toYYYYMMDD(start),
            endDate: toYYYYMMDD(today),
        }
    }

    if (preset === 'last_month') {
        const firstOfThisMonth = new Date(
            today.getFullYear(),
            today.getMonth(),
            1,
        )
        const lastOfPrev = new Date(firstOfThisMonth.getTime() - 1)
        const firstOfPrev = new Date(
            lastOfPrev.getFullYear(),
            lastOfPrev.getMonth(),
            1,
        )
        return {
            startDate: toYYYYMMDD(firstOfPrev),
            endDate: toYYYYMMDD(
                new Date(
                    lastOfPrev.getFullYear(),
                    lastOfPrev.getMonth() + 1,
                    0,
                ),
            ),
        }
    }

    const currentQuarterStartMonth = Math.floor(today.getMonth() / 3) * 3
    const lastQuarterEnd = new Date(
        today.getFullYear(),
        currentQuarterStartMonth,
        0,
    )
    const lastQuarterStart = new Date(
        lastQuarterEnd.getFullYear(),
        lastQuarterEnd.getMonth() - 2,
        1,
    )
    return {
        startDate: toYYYYMMDD(lastQuarterStart),
        endDate: toYYYYMMDD(lastQuarterEnd),
    }
}

export const getDefaultDateRange = () =>
    getPresetRange(DEFAULT_VENDOR_PERFORMANCE_PRESET)

export const isDateRangeReady = (startDate: string, endDate: string) =>
    (!startDate && !endDate) || (Boolean(startDate) && Boolean(endDate))

export const isDateRangeValid = (startDate: string, endDate: string) =>
    !(startDate && endDate && startDate > endDate)
